module.exports = __webpack_public_path__ + "static/media/tcs_small_logo.68ca154a.png";